import styled from 'styled-components';

import { CommonFlex } from '../../../styledComponents/common';

export const ScrollableContainer = styled.div`
  overflow-x: auto;
  overflow-y: visible;
  padding: 30px 0;
  position: relative;
  margin-top: -20px;
  width: 100%;
  min-width: 100%;
  display: flex;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
`;

export const VerticalScale = styled.div`
  width: 50px;
  height: 25px;
  text-align: right;
  color: ${({ theme }) => theme.font?.pageText?.colorSecondary || '#6F7FA2'};
  font-size: 12px;
`;

export const BarContainer = styled.div`
  height: 100%;
  position: relative;
`;

export const Bar = styled.div`
  width: 30px;
  background-color: ${({ bgColor }) => bgColor};
  position: relative;
  color: transparent;
  height: ${({ height }) => height || '2px'};
  min-height: 2px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    opacity: 0.8;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  }
`;

export const TooltipWrapper = styled.div`
  position: absolute;
  left: -30px;
  width: 200px;
  height: min-content;
  z-index: 1000;
`;

export const HorizontalScale = styled.div`
  width: ${({ width }) => width};
  border-bottom: 1px dotted
    ${({ theme }) => theme.colors?.border?.secondary || '#e4e7eb'};
  color: transparent;
  text-align: left;
  height: 25px;
  overflow: visible;
`;

export const AbsoluteScaleContainer = styled(CommonFlex)`
  position: absolute;
  top: -14px;
  left: 52px;
  z-index: 1;
  padding-top: 30px;
  text-align: start;
`;

export const CenteredText = styled(CommonFlex)`
  width: 100%;
  justify-content: center;
  margin-top: 10px;
  font-size: 14px;
  color: ${({ theme }) => theme.font?.pageText?.colorSecondary || '#6F7FA2'};
`;

export const LegendContainer = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
  margin: 15px 0;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendColor = styled.div`
  width: 15px;
  height: 15px;
  background-color: ${({ color }) => color};
  border-radius: 3px;
`;

export const LegendText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.font?.pageText?.colorSecondary || '#6F7FA2'};
`;

export const ChartContainer = styled.div`
  width: 100%;
  position: relative;
`;
